import { AiProcessStepExecutionStatus } from 'constants/aiProcessRuns';

export const STATUS_TO_BAR_PALETTE = {
  [AiProcessStepExecutionStatus.RUNNING]: 'info',
  [AiProcessStepExecutionStatus.AWAITING_CONFIRMATION]: 'warning',
  [AiProcessStepExecutionStatus.AWAITING_USER_INPUT]: 'warning',
  [AiProcessStepExecutionStatus.COMPLETED]: 'success',
  [AiProcessStepExecutionStatus.FAILED]: 'error',
};

export const MIN_BAR_WIDTH_PERCENT = 0.8;
export const PERCENT_MAX = 100;
export const TIMELINE_TITLE = 'Timeline';
export const TIMELINE_SUMMARY_SEPARATOR = ' · ';
export const TIMELINE_TOGGLE_LABELS = {
  SHOW: 'Show timeline',
  HIDE: 'Hide timeline',
};
export const OVERLAP_TOLERANCE = 1.05;
export const IDLE_WAIT_AXIS_PADDING = 0.15;
export const OPEN_ENDED_STRIPE_PX = 6;
export const WAITING_BAR_SUFFIX = ' · waiting for your input';
